import { render, staticRenderFns } from "./OnlineClassManageSetting.vue?vue&type=template&id=3b52fb10&scoped=true&"
import script from "./OnlineClassManageSetting.vue?vue&type=script&lang=js&"
export * from "./OnlineClassManageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52fb10",
  null
  
)

export default component.exports